module.exports = __webpack_public_path__ + "static/media/leftBg.efa6ad3b.png";